import styled from "styled-components";

export const UtilityPage = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 2rem;
  margin-top: 2rem;
`;

export const CardContainer = styled.div`
  background-color: #ffffff;
  border-radius: 8px;
  padding: 16px;
  flex-basis: 300px;
  cursor: ${({ disabled }) => (disabled ? "" : "pointer")};
  pointer-events: ${({ disabled }) => (disabled ? "none" : "auto")};
  border: ${({ disabled }) =>
    disabled ? "2px dashed #e5e5e5" : "0.5px solid #e5e5e5"};
  font-family: "Inter", sans-serif;
  transition: 0.2s ease-in-out all;
  & h2 {
    font-size: 16px;
    font-weight: bold;
    margin-bottom: 8px;
    color: ${({ disabled }) => (disabled ? "#a1a1a1" : "black")};
  }
  & p {
    font-size: 14px;
    line-height: 20px;
    color: ${({ disabled }) => (disabled ? "#c4c4c4" : "#888888")};
  }
  &:hover {
    box-shadow: ${({ disabled }) =>
      disabled ? "" : "0px 4px 8px rgba(0, 0, 0, 0.05)"};
  }
`;

export const InsurerCardWrapper = styled.div`
  margin: 1rem;
  border-radius: 10px;
  outline: ${({ selected }) =>
    selected ? "1px solid #000" : "0.5px solid #e5e5e5"};
  display: flex;
  flex: 0 0 160px;
  width: 160px;
  height: 140px; /* Set a fixed height */
  align-items: center;
  flex-direction: column;
  padding: 1.5rem;
  text-align: center;
  cursor: pointer;
  transition: 0.2s ease-in-out all;
  scale: ${({ selected }) => (selected ? "1.1" : "1")};
  transition: 0.2s ease-in-out all;

  & footer {
    flex-basis: 40%;
    display: grid;
    place-items: center;
    color: ${({ selected }) => (selected ? "#000" : "#333")};
  }
  & div {
    flex-basis: 60%;
    display: grid;
    place-items: center;
  }
  &:hover {
    box-shadow: ${({ disabled }) =>
      disabled ? "" : "0px 4px 8px rgba(0, 0, 0, 0.05)"};
    transform: ${({ selected }) => (selected ? "scale(1.01)" : "scale(1.05)")};
  }
`;

export const ProviderName = styled.h2`
  font-size: 12px;
  color: #333;
`;

export const ProviderLogo = styled.img`
  max-width: 60px;
  max-height: 40px;
  margin-bottom: 1rem;
`;
